export default { 
  name : 'segment.images',
  objectType : 'segment',
  valueType : 'string@',
  displayName : 'Segment Images',
  get : ( obj, cxt ) => {
    if ( !cxt.imageView ) {
      return null
    }

    return obj.data?.images?.[cxt.imageView]
  }
}
